export const CINEMA_NAMES = [
    { id: 1, name: 'České Budějovice Čtyři Dvory', slug: 'budejovice' },
    { id: 2, name: 'Hradec Králové', slug: 'hradec' },
    { id: 3, name: 'Jihlava', slug: 'jihlava' },
    { id: 4, name: 'Liberec', slug: 'liberec' },
    { id: 5, name: 'Mladá Boleslav', slug: 'boleslav' },
    { id: 6, name: 'Olomouc', slug: 'olomouc' },
    { id: 7, name: 'Opava', slug: 'opava' },
    { id: 8, name: 'Ostrava', slug: 'ostrava' },
    { id: 9, name: 'Pardubice', slug: 'pardubice' },
    { id: 10, name: 'Plzeň', slug: 'plzen' },
    { id: 11, name: 'Praha Anděl', slug: 'praha5' },
    { id: 12, name: 'Praha Černý Most', slug: 'praha9' },
    { id: 14, name: 'České Budějovice IGY Centrum', slug: 'budejovice-igy' },
]

export const cinemaSlugToId = (cinemaSlug) => {
    const cinemaId = CINEMA_NAMES.find((cinema) => cinema.slug === cinemaSlug)?.id
    return cinemaId
}

export const normalizeCinemaId = (value) => {
    if (typeof value !== 'string' && typeof value !== 'number') return null
    const id = Number(value)
    return Number.isInteger(id) && id > 0 && id <= 2147483647 ? id : null
}
